module.exports = __webpack_public_path__ + "img/s6.0.1.0_202602051651.jpg";